<template>
  <div class="footer" >
      <!-- <span v-html="copyright"></span> -->
      <!-- <span v-html="beian"></span> -->
      <a style="color:blue" href='https://beian.miit.gov.cn/' target='_blank'>备案号：闽ICP备2024046577号-1</a>
  </div>
</template>

<script>

  export default {
    data() {
      return {
       copyright:window.config.copyright,
       beian:window.config.beian
      }
    },

  }
</script>

<style lang="less" scoped>
  .footer {
      text-align: center;
      font-size: 14px;
      margin-top:34%;
      span{
          margin: 0 10px;
          margin-top: 10px;
      }
  }
</style>